export const PHARMACY_QA_SET_SIDEBAR = 'PHARMACY_QA_SET_SIDEBAR';
export const PHARMACY_QA_SET_FILTERS = 'PHARMACY_QA_SET_FILTERS';
export const PHARMACY_QA_SET_FILTERS_DATA = 'PHARMACY_QA_SET_FILTERS_DATA';
export const PHARMACY_QA_SET_FILTERS_LOADING = 'PHARMACY_QA_SET_FILTERS_LOADING';
export const PHARMACY_QA_SET_FILTERS_SUMMARY = 'PHARMACY_QA_SET_FILTERS_SUMMARY';
export const PHARMACY_QA_SET_DATA = 'PHARMACY_QA_SET_DATA';
export const PHARMACY_QA_SET_LOADING = 'PHARMACY_QA_SET_LOADING';
export const PHARMACY_QA_SET_SITES_DATA = 'PHARMACY_QA_SET_SITES_DATA';
export const PHARMACY_QA_SET_SITES_LOADING = 'PHARMACY_QA_SET_SITES_LOADING';
